export const blockIconsFileTextSnippet = (
	<span className='material-symbols-outlined'>text_snippet</span>
);
